import { Component, Input } from '@angular/core';
import { IUserHistory } from '@soleran/audit';

@Component({
  selector: 'app-global-search-history-results',
  template: `
    <mat-divider></mat-divider>
    <mat-nav-list dense>
      <a
        *ngFor="let h of results"
        mat-list-item
        [routerLink]="[
          '/module',
          h.recordLink.moduleId,
          'detail',
          h.recordLink.recordId
        ]"
      >
        <mat-icon [style.overflow]="'visible'" class="text-muted" mat-list-icon
          >history</mat-icon
        >
        <div mat-line class="list-item-text-container no-wrap">
          <app-module-icon [icon]="h.icon"></app-module-icon>
          <span [innerText]="h.name"></span>
        </div>
      </a>
      <mat-divider></mat-divider>
    </mat-nav-list>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
      }
      ::ng-deep .mat-mdc-list-item .mdc-list-item__primary-text {
        display: flex;
      }
      [mat-line].list-item-text-container.list-item-text-container {
        display: flex;
        align-items: center;
      }
      app-module-icon {
        margin: 0 8px;
      }
    `,
  ],
})
export class GlobalSearchHistoryResultsComponent {
  @Input()
  results: IUserHistory[] = [];
}
